import {Button, Card, Form, Select, Spin} from 'antd';
import React from "react";
import {getFormFieldByType, sanitizeFieldName} from "../../util/methods";

class Create extends React.Component {

  state = {
    // attributes: ['QR', 'RFID', 'GPS', 'OUTDOOR', 'METALLIC']
  }

  componentDidMount() {
    const {match, fetch} = this.props;
    this.props.getAllTagAttributes();
    if (match.params && match.params.id) {
      fetch(match.params.id);
    }
  }

  handleSubmit = (e) => {
    const {match} = this.props;
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (err) {
        return console.log(err);
      }
      // console.log(values);
      if (match.params && match.params.id) {
        this.props.onSubmit(values, match.params.id);
      } else {
        this.props.onSubmit(values);
      }
    });
  };

  // handleChangeAttributes = (attributes) => {
  //     console.log(attributes)
  //     this.setState({attributes})
  // } allAttributes={this.props.allAttributes}
  //                                           getAllTagAttributes={this.props.getAllTagAttributes}

  render() {
    const {getFieldDecorator} = this.props.form;
    const {data, loading, filters, title, resource, form, allAttributes} = this.props;
    // console.log(allAttributes)
    // const attributes = filters && filters['attributes'] && filters['attributes']['data'] || [];

    return (
      <Spin spinning={loading}>
        <Card className={`gx-card-metrics`} title={`${title} ${sanitizeFieldName(resource)}`}>
          <Form onSubmit={this.handleSubmit} layout="vertical">

            {Object.keys(filters).map((item) => {
              if (filters[item].type === 'Array' && item === 'attributes') {
                return (
                  <Form.Item key={item} label={filters[item].options.label}>
                    {getFieldDecorator(item, {
                      rules: [
                        {required: true, message: `${item} is required!`}
                      ],
                      initialValue: data && data[item]
                    })(
                      <Select
                        mode="multiple"
                        style={{width: "100%"}}
                        placeholder="Please select"
                        // onChange={this.handleChangeAttributes}
                      >
                        {allAttributes &&
                          allAttributes.length &&
                          allAttributes.map(item => (
                            <Select.Option key={item._id} value={item.name}>
                              {item.name}
                            </Select.Option>
                          ))}
                      </Select>
                    )}
                  </Form.Item>
                );
              } else {
                return getFormFieldByType(filters, item, getFieldDecorator, data, {
                  title: title,
                  resource
                })
              }
            })}

            <Form.Item>
              <Button type="primary" className="gx-mb-0" htmlType="submit" loading={loading}>
                {this.props.title === 'EDIT' ? 'UPDATE' : 'CREATE'}
              </Button>
            </Form.Item>
          </Form>
        </Card>
      </Spin>
    );
  }
}

const CreateForm = Form.create({
  name: 'global_state',
  onFieldsChange(props, changedFields) {
    props.onChange(changedFields);
  },
})(Create);

export default CreateForm;
